export default "__VITE_ASSET__DasRgAov__"